import React from 'react'
import { Link } from 'react-router-dom'
import unpluged from '../../../assets/Images/unpluged.svg'

const Error = ({role}) => {
  return (
    <div className='container'>
      <div className='row'>
        <div className='col-12' style={{textAlign: 'center', margin: '20vh 0px 0px' }}>
          <img src={unpluged} alt="Icono desconectado" />
            <h1>¡Rayos!</h1>
            <h5 className='mb-4'>Parece que lo que buscas no existe</h5>
              <Link to='/' className='btn btn-dark'>Regresar al inicio</Link>
        </div>
      </div>
    </div>
  )
}

export default Error